import { jsx as _jsx } from "react/jsx-runtime";
import { useFormContext } from "react-hook-form";
import { CheckboxGroup } from "./CheckboxGroup";
import { InputTypes } from "./CustomizeModal-types";
import { getCustomizationFieldName } from "./CustomizeModal-utils";
import { MultiSelect } from "./MultiSelect";
import { RadioButtonGroup } from "./RadioButtonGroup";
import { SingleSelect } from "./SingleSelect";
export const CustomizeFormInputs = ({ inputType, multiple, maxLimit, required, helperText, ingredient, customizationsOptionsSubtext }) => {
    var _a, _b, _c, _d;
    const { control } = useFormContext();
    if (inputType === InputTypes.DROPDOWN) {
        if (multiple) {
            return (_jsx(MultiSelect, { control: control, label: (_a = ingredient.IngredientType) !== null && _a !== void 0 ? _a : ingredient.IngredientName, name: getCustomizationFieldName(ingredient), options: ingredient.IngredientOptions.map((ingOption) => ({
                    label: ingOption.Name ? ingOption.Name : ingOption.IngredientName,
                    price: ingOption.IngredientPrice,
                    value: ingOption.IngredientOptionId,
                })), max: maxLimit, helperText: helperText, required: required }, ingredient.IngredientId));
        }
        else {
            return (_jsx(SingleSelect, { control: control, label: (_b = ingredient.IngredientType) !== null && _b !== void 0 ? _b : ingredient.IngredientName, name: getCustomizationFieldName(ingredient), options: ingredient.IngredientOptions.map((ingOption) => ({
                    label: ingOption.Name ? ingOption.Name : ingOption.IngredientName,
                    price: ingOption.IngredientPrice,
                    value: ingOption.IngredientOptionId,
                })), helperText: helperText, required: required }, ingredient.IngredientId));
        }
    }
    if (inputType === InputTypes.RADIOBUTTON) {
        return (_jsx(RadioButtonGroup, { control: control, label: (_c = ingredient.IngredientType) !== null && _c !== void 0 ? _c : ingredient.IngredientName, name: getCustomizationFieldName(ingredient), options: ingredient.IngredientOptions.map((ingOption) => ({
                label: ingOption.Name ? ingOption.Name : ingOption.IngredientName,
                price: ingOption.IngredientPrice,
                value: ingOption.IngredientOptionId,
            })), max: maxLimit, helperText: helperText, required: required }, ingredient.IngredientId));
    }
    if (inputType === InputTypes.CHECKBOX) {
        return (_jsx(CheckboxGroup, { control: control, label: (_d = ingredient.IngredientType) !== null && _d !== void 0 ? _d : ingredient.IngredientName, name: getCustomizationFieldName(ingredient), options: ingredient.IngredientOptions.map((ingOption) => ({
                label: ingOption.Name ? ingOption.Name : ingOption.IngredientName,
                price: ingOption.IngredientPrice,
                value: ingOption.IngredientOptionId,
            })), max: maxLimit, helperText: helperText, required: required }, ingredient.IngredientId));
    }
    return null;
};
